import useComposerEvents from '~/hooks/home/useComposerEvents';

export default function PagesRouterComposerEvents() {
  useComposerEvents();

  return null;
}
